import React from 'react'
import { css } from '@emotion/css'
import { theme } from '@contrast-security-inc/design-system-foundations'
import { theme as deprecatedTheme } from '../../../styled'

const tooltipLabelTextCss = css`
  @media (max-width: 768px) {
    display: flex;
  }
  @media (max-width: 700px) {
    display: flex;
    word-wrap: break-word;
    max-width: 200px;
  }
  @media (max-width: 500px) {
    display: flex;
    word-wrap: break-word;
    max-width: 130px;
  }
  font-family: ${deprecatedTheme.fontFamilies.secondary};
  font-weight: 500;
  color: ${theme.color.white};
`

interface LabelProps {
  readonly children: string | React.ReactNode
}

export function TooltipLabelText({ children }: LabelProps) {
  return <span className={tooltipLabelTextCss} children={children} />
}
